import { render, staticRenderFns } from "./PhoneNumberMapper.vue?vue&type=template&id=5de9fb79"
import script from "./PhoneNumberMapper.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports